export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = useSupabaseUser();

  // Exact routes that require user to be logged in
  const authRequiredRoutesExact = [
    "/subscription",
    "/subscription/checkout",
    "/users/settings",
    "/",
    "/search-history",
  ];

  // All routes within these folders require user to be logged in
  const authRequiredRoutesFolder = [
    "/content/",
    "/inquiry-report/",
    "report/",
  ];

  const authRequiredRoutesExceptions = [
    "/report/sample",
  ];

  // Exact routes that require user to be an admin
  const adminRequiredRoutesExact = [
    "/users",
    "/content",
    "/zoning-editor",
    "/modules-editor",
    "/feedback",
    "/demo",
  ];

  // All routes within these folders require user to be an admin
  const adminRequiredRoutesFolder = [
    "/zoning-editor/",
    "/modules-editor/",
    "/blog"
  ];

  // All routes within these folders that require user to be a planner
  const plannerRequiredRoutesFolder = [
    "/inquiry-report/planner/",
  ];

  // All routes within these folders that require user to be a planner
  const plannerRequiredRouteExact = [
    "/inquiry-analytics"
  ];

  // Redirects for old links
  const redirectRoutes = [
    {
      from: '/parcels/sample',
      to: '/report/sample',
    },
    {
      from: '/full-report/sample',
      to: '/report/sample',
    },
    {
      from: '/development-report/sample',
      to: '/report/sample',
    },
  ];

  // Check if the current route is an auth required route via exact match or within the folder
  const isAuthRequiredRoute = ((authRequiredRoutesExact.some((p) => to.path.toLowerCase() == p) || authRequiredRoutesFolder.some((p) => to.path.toLowerCase().includes(p))) && !authRequiredRoutesExceptions.some((p) => to.path.toLowerCase().includes(p)));

  // Check if the current route is an admin route
  const isAdminRequiredRoute = (adminRequiredRoutesExact.some((p) => to.path.toLowerCase() == p) || adminRequiredRoutesFolder.some((p) => to.path.toLowerCase().includes(p)));

  // Check if the current route is a planner route
  const isPlannerRequiredRoute = plannerRequiredRoutesFolder.some((p) => to.path.toLowerCase().includes(p)) || plannerRequiredRouteExact.some((p) => to.path.toLowerCase() == p);

  // 
  // Redirection Logic:
  // 

  if ((isAuthRequiredRoute || isAdminRequiredRoute || isPlannerRequiredRoute) && !user.value) {
    // Redirect to login page if user is not logged in on page that requires auth
    if (to.path.toLowerCase() == "/") {
      return navigateTo("/auth");
    }
    else {
      return navigateTo("/auth?redirect=" + to.path.slice(1));
    }
  }
  else if (isAdminRequiredRoute) {
    // Only check for admin on admin routes
    const profileDataCookie = useCookie('profileData');
    if (profileDataCookie.value.subscription != 'admin') {
      return navigateTo("/");
    }
  }
  else if (isPlannerRequiredRoute) {
    // Only check for planner on planner routes
    const profileDataCookie = useCookie('profileData');
    // Allow admins to view planner pages too
    if (profileDataCookie.value.subscription != 'planner' && profileDataCookie.value.subscription != 'admin') {
      return navigateTo("/");
    }
  }
  else if (redirectRoutes.some((p) => to.path.toLowerCase().includes(p.from))) {
    // Redirect to new route if old route is found
    return navigateTo(redirectRoutes.find((p) => to.path.toLowerCase().includes(p.from)).to);
  }
  else if (user.value && to.path == "/auth") {
    // Redirect to home page if user is logged in and tries to go to login page
    return window.location.href = "/";
  }
});
